var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.field.component,{tag:"component",attrs:{"form":_vm.form,"field":_vm.field,"full-key":_vm.fullKey,"meta":typeof _vm.field.meta === 'function' ? _vm.field.meta(_vm.form.entry) : _vm.field.meta,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }